
import NumberInput from './numberinput'

export default NumberInput;